import { createBaseApi } from "../baseApi";
import { ProfileModel } from "model/profile/profile.schema";
import { LogsModel } from "model/profile/logs.schema";
import PayloadModel from "model/_payload/payload.schema";

// Create profile API with base configuration
export const profileApi = createBaseApi("profile", "/profile").injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    // Get Profile
    getProfile: builder.query({
      query: () => ({
        url: "",
        method: "GET",
      }),
      transformResponse: (response) => ProfileModel.jsonToModel(response),
    }),

    // Update Profile
    updateProfile: builder.mutation({
      query: (payload) => ({
        url: "",
        method: "PATCH",
        body: payload,
      }),
      transformResponse: (response) => ProfileModel.jsonToModel(response),
    }),

    // Get Logs
    getLogs: builder.query({
      query: (value) => ({
        url: "/logs",
        method: "GET",
        params: PayloadModel.modelToJson(value),
      }),
      transformResponse: (response) => LogsModel.jsonToModel(response),
    }),
  }),
});

export const { useGetProfileQuery, useUpdateProfileMutation, useGetLogsQuery } = profileApi;
